/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { Line } from 'three';
let Shape3DPolyline = class Shape3DPolyline extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createPolylineUnsafe(shape.points);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new Line(geometry, CrownShape.getLineMaterial(decoration)));
        }
    }
    format() {
        const { source } = this.transformPose();
        const points = new Array();
        const { vertices } = this.geometry;
        if (source.isClosed) {
            vertices.pop();
        }
        vertices.forEach((v) => {
            points.push(v);
        });
        return {
            points,
            isClosed: source.isClosed,
        };
    }
};
Shape3DPolyline = tslib_1.__decorate([
    Shape('Shape3D.PolyLine'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DPolyline);
export { Shape3DPolyline };
//# sourceMappingURL=Shape3DPolyline.js.map